import {
  DotsThreeVertical,
  PencilSimpleLine,
  Trash,
} from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "common/components/ui/TableV2";

import { formatBillingDate } from "../../utils";
import ApiTokenTag from "./ApiTokenTag";

import type { ApiToken } from "../../types";

interface DesktopTableProps {
  tokens: ApiToken[];
  onEdit: (apiToken: ApiToken) => void;
  onDelete: (apiToken: ApiToken) => void;
}

export default function DesktopTable({
  tokens,
  onEdit,
  onDelete,
}: DesktopTableProps) {
  return (
    <Table>
      {/* Table header component */}
      <thead>
        <tr>
          <TableHead className="w-64">Key name</TableHead>
          <TableHead className="w-32">Permissions</TableHead>
          <TableHead className="w-52">Key</TableHead>
          <TableHead>Created at</TableHead>
          <TableHead />
        </tr>
      </thead>

      {/* Table body */}
      <tbody>
        {tokens.map((token) => {
          const {
            id,
            name,
            token: tokenId,
            created_at: createdAt,
            write: canWrite,
            read: canRead,
          } = token;

          const permissions = canWrite && canRead ? "All" : "Read only";

          return (
            <TableRow key={id}>
              {/* Token name */}
              <TableCell className="text-sm-bold">{name}</TableCell>

              {/* Token permission */}
              <TableCell className="text-button-xs">{permissions}</TableCell>

              {/* Token ID / Key */}
              <TableCell>
                <ApiTokenTag tokenId={tokenId} />
              </TableCell>

              {/* Token created at date */}
              <TableCell className="text-button-xs">
                {formatBillingDate(createdAt)}
              </TableCell>

              {/* Actions buttons for editing & deleting tokens */}
              <TableCell>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      intent="iconOnly"
                      variant="secondary-black"
                      size="sm"
                    >
                      <DotsThreeVertical />
                    </Button>
                  </DropdownMenuTrigger>

                  <DropdownMenuContent align="end">
                    <DropdownMenuList>
                      <DropdownMenuItem onClick={() => onEdit(token)}>
                        <PencilSimpleLine /> Edit
                      </DropdownMenuItem>

                      <DropdownMenuItem
                        variant="danger"
                        onClick={(e) => {
                          e.stopPropagation();
                          onDelete(token);
                        }}
                      >
                        <Trash />
                        Delete
                      </DropdownMenuItem>
                    </DropdownMenuList>
                  </DropdownMenuContent>
                </DropdownMenu>
              </TableCell>
            </TableRow>
          );
        })}
      </tbody>
    </Table>
  );
}
